import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo, useMemo, useState } from "react";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { TransactionCTAColumn } from "@common/types/views/transactionViews";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { Tooltip } from "@design-system/Tooltip/Tooltip";

export const TransactionCTACell = memo(
    ({
        row,
        column,
    }: CellContext<ViewTableFeatures, TransactionListItem, any>) => {
        const options =
            (column.columnDef.meta as NonNullable<
                TransactionCTAColumn["options"]
            >) ?? {};
        const { isDisabled, tooltip, onClick, label } = options;
        const [loading, setLoading] = useState(false);

        const displayedLabel = useMemo(() => {
            if (typeof label === "function") {
                return label(row.original);
            }
            return label;
        }, [label, row.original]);

        const disabled = useMemo(
            () => isDisabled?.(row.original) ?? false,
            [isDisabled, row.original],
        );
        const tooltipText = useMemo(() => {
            if (typeof tooltip === "function") {
                return tooltip(row.original);
            }
            return tooltip;
        }, [tooltip, row.original]);

        return (
            <ViewTableCell>
                <Tooltip content={tooltipText}>
                    <ButtonWithLoader
                        onClick={() => onClick(row.original)}
                        loading={loading}
                        setLoading={setLoading}
                        variant="primary"
                        size="sm"
                        disabled={disabled}
                    >
                        {displayedLabel}
                    </ButtonWithLoader>
                </Tooltip>
            </ViewTableCell>
        );
    },
);
TransactionCTACell.displayName = "TransactionCTACell";
